<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Character' }" tag="li" class="breadcrumb-item">
						<a href="#">人物列表</a>
					</router-link>
					<li class="breadcrumb-item active" aria-current="page">
						{{ unitName }}
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<div class="row mb-3">
					<div class="col-lg-7 col-md-7 col-12">
						<h2 class="item-title">{{ $t("unit_big_image") }}</h2>
						<div class="owl-carousel owl-theme owl-loaded owl1">
							<div>
								<img class="d-block mx-auto img-fluid chara-thumb-img"
									:src="'/static/images/unit_big/unit_big_' + (Number(this.unit_id) + 30) + '.jpg'"
									alt="" />
							</div>
							<div v-if="star6">
								<img class="d-block mx-auto img-fluid chara-thumb-img"
									:src="'/static/images/unit_big/unit_big_' + (Number(this.unit_id) + 60) + '.jpg'"
									alt="" />
							</div>
						</div>
						<span class="my-3 d-block">
							<h3 class="item-title">{{ $t("Introduction") }}</h3>
							<div v-html="unitComment"></div>
						</span>
					</div>
					<div class="col-lg-5 col-md-5 col-12">
						<h2 class="item-title">{{ $t("unit_info") }}</h2>
						<table class="chara-table">
							<tr>
								<th width="30%">{{ $t("unit_name") }}</th>
								<td>
									<p v-if="unit_data.tw_unit_name != unit_data.cn_unit_name">
										tw: {{ unit_data.tw_unit_name }}
									</p>
									<p v-if="unit_data.jp_unit_name != unit_data.cn_unit_name">
										cn: {{ unit_data.cn_unit_name }}
									</p>
									<p>jp: {{ unit_data.jp_unit_name }}</p>
									<p v-if="unit_data.en_unit_name != unit_data.cn_unit_name">
										en: {{ unit_data.en_unit_name }}
									</p>
								</td>
							</tr>
							<tr>
								<th>{{ $t("gacha_pool") }}</th>
								<td>{{ getGachaType }}</td>
							</tr>
							<tr>
								<th>{{ $t("element") }}</th>
								<td>
									<span :class="'mx-auto icon icon-ele t' + unit_profile.talent_id"></span>
								</td>
							</tr>

							<tr>
								<th>{{ $t("Guild") }}</th>
								<td>{{ unitGuild }}</td>
							</tr>
							<tr>
								<th>{{ $t("Birthday") }}</th>
								<td>{{ unit_profile.birth_month }} / {{ unit_profile.birth_day }}</td>
							</tr>
							<tr>
								<th>{{ $t("Age") }}</th>
								<td>{{ unit_profile.age }}</td>
							</tr>
							<tr>
								<th>{{ $t("Height") }}</th>
								<td>{{ unit_profile.height }}</td>
							</tr>
							<tr>
								<th>{{ $t("Weight") }}</th>
								<td>{{ unit_profile.weight }}</td>
							</tr>
							<tr>
								<th>{{ $t("BloodType") }}</th>
								<td>{{ unit_profile.blood_type }}</td>
							</tr>
							<tr>
								<th>{{ $t("Race") }}</th>
								<td>{{ unitRace }}</td>
							</tr>
							<tr>
								<th>{{ $t("Favorite") }}</th>
								<td>{{ unitFavorite }}</td>
							</tr>
							<tr>
								<th>{{ $t("VoiceActress") }}</th>
								<td>{{ unitVoice }}</td>
							</tr>
						</table>
					</div>
				</div>
				<div class="row my-3"></div>
				<div class="row my-3">
					<div class="col-12 col-lg-7">
						<h3 class="item-title">{{ $t("EquipmentMenu") }}</h3>
						<div class="chara-equipment-box my-3">
							<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
								<li class="nav-item m-1" v-for="(item, index) in unit_promotion">
									<a class="pcbtn" :class="index + 1 == unit_promotion.length ? 'active' : ''"
										role="tab"
										:aria-selected="index + 1 == unit_promotion.length ? 'true' : 'false'"
										data-toggle="pill" :id="'nav-' + index + '-tab'" :href="'#nav-' + index"
										:aria-controls="'nav-' + index">
										Rank <span class="d-inline-block" style="width: 20px">{{ index + 1 }}</span>
									</a>
								</li>
							</ul>
							<div class="tab-content pt-3 armory-bg" id="nav-tabContent">
								<div v-for="(level, index) in unit_promotion" class="tab-pane fade"
									:class="index + 1 == unit_promotion.length ? 'active show' : ''"
									:id="'nav-' + index" role="tabpanel" :aria-labelledby="'nav-' + index + '-tab'">
									<div class="armory-unit-box unit-bg-img p-3" :style="getCharaImg(unit_id)">
										<div class="equipment">
											<div class="row">
												<div class="col-6 mb-3" :class="leftOrRight(index1)"
													v-for="(item, index1, key) in level">
													<span class="eq-box" v-if="item.eq_id != null">
														<router-link
															:to="{ name: 'EquipmentDetail', params: { id: item.eq_name } }"
															v-if="item.eq_id != '999999'">
															<img width="80" class="img-fluid"
																:src="'/static/images/equipment/icon_equipment_' + item.eq_id + '.png'" />
														</router-link>
														<img width="80" class="img-fluid"
															:src="'/static/images/equipment/icon_equipment_' + item.eq_id + '.png'"
															v-else />
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-5">
						<h3 class="item-title mb-3">
							{{ $t("Bond_Level_Bonus") }}
							<button @click="activeRankBonus" class="pcbtn ml-3 float-right"
								:class="this.RankBonus ? 'active' : ''">
								Rank Bonus
							</button>
						</h3>
						<div class="owl-carousel owl-carousel2 owl-theme owl-loaded"
							v-if="Object.values(unit_story).filter(Boolean).length > 1">
							<template v-for="(items, index) in unit_story">
								<div>
									<table class="chara-table mb-3" style="width:99%">
										<tr>
											<th colspan="2">{{ getUnitName(index) }}</th>
										</tr>
										<tr v-for="(item, index) in items">
											<th>第 {{ index + 2 }} 話</th>
											<td>
												<div v-for="index in 5">
													<div v-if="item['status_rate_' + index] != '0'">{{
														getStatusName(item["status_type_" + index]) }} + {{
															item["status_rate_" + index] }}</div>
												</div>
											</td>
										</tr>
									</table>
								</div>
							</template>
						</div>
						<template v-for="(items, index) in unit_story" v-else>
							<table class="chara-table mb-3" style="width:99%">
								<tr>
									<th colspan="2">{{ getUnitName(index) }}</th>
								</tr>
								<tr v-for="(item, index) in items">
									<th>第 {{ index + 2 }} 話</th>
									<td>
										<div v-for="index in 5">
											<div v-if="item['status_rate_' + index] != '0'">{{
												getStatusName(item["status_type_" + index]) }} + {{ item["status_rate_"
													+ index] }}</div>
										</div>
									</td>
								</tr>
							</table>
						</template>
					</div>
				</div>
				<h3 class="item-title mb-0">{{ $t("AttackPattern") }}</h3>
				<div class="row my-3">
					<template v-for="(pattern, index) in unit_attack_pattern">
						<div class="col-12" v-if="unit_attack_pattern.length > 1">
							<h3 class="item-sub-title mb-0">模式 {{ index + 1 }}</h3>
						</div>
						<div class="col-12 col-lg-6">
							<h4 class="item-sub-title mb-0">{{ $t("FirstStart") }}</h4>
							<div class="d-flex flex-wrap">
								<div v-for="(item, index) in pattern.start">
									<img class="img-fluid my-2" width="50"
										:src="'/static/images/skill/icon_skill_' + item + '.png'" alt="" />
									<span class="mx-2" v-if="index + 1 < pattern.start.length">
										→
									</span>
								</div>
							</div>
						</div>
						<div class="col-12 col-lg-6">
							<h4 class="item-sub-title mb-0">{{ $t("Loop") }}</h4>
							<div class="d-flex flex-wrap">
								<div v-for="(item, index) in pattern.loop">
									<img class="img-fluid my-2" width="50"
										:src="'/static/images/skill/icon_skill_' + item + '.png'" alt="" />
									<span class="mx-2" v-if="pattern.loop.length - 1 == index">
										↻
									</span>
									<span v-else class="mx-2">→</span>
								</div>
							</div>
						</div>
					</template>
				</div>
				<div class="my-3" v-if="getExEq.length > 0">
					<h3 class="item-title mb-0">Ex {{ $t("UniqueEquipment") }}</h3>
					<div class="row my-3">
						<div class="col-12">
							<div class="prod-info-box unique mb-3">
								<button v-for="item in getExEq" class="pcbtn danger m-1"
									:style="'background:' + item.outline">
									<router-link :to="{ name: 'ExEquipment' }">
										<div style="color:white">
											{{ getI18nName(item, "category_name") }}
										</div>
									</router-link>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div v-if="unit_unique_equip_data.length > 0">
					<div class="row my-3">
						<template v-for="item in unit_unique_equip_data">
							<div class="col-12 mb-3">
								<h3 class="item-title mb-3">{{ $t("UniqueEquipment") }} {{ item.slot_type }}</h3>
								<div class="prod-info-box unique mb-3">
									<h2 id="0">{{ getI18nName(item, "equipment_name") }}</h2>
									<div class="row py-3">
										<div class="col-lg-4 col-12 text-center pb-3">
											<div class="d-flex justify-content-center align-items-center"
												style="height: 100%">
												<img class="img-fluid"
													:src="'/static/images/equipment/icon_equipment_' + item.equipment_id + '.png'" />
											</div>
										</div>
										<div class="col-lg-8 col-12">
											<div class="uq-title my-3 pb-1"><span>♦</span> {{ $t("item_description") }}
											</div>
											<p>{{ replaceNword(getI18nName(item, "description")) }}</p>
											<!-- <p>LV : {{ uniqueWeaponLevel }}</p> -->
											<div class="uq-title my-3 pb-1"><span>♦</span> {{ $t("UELevel") }}</div>
											<div class="row">
												<div class="col-12 mb-3">
													<template v-if="item.slot_type === '1'">
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 29 ? 'active' : ''"
															@click="setUqLevel(30, item.slot_type)">
															Lv 30
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 49 ? 'active' : ''"
															@click="setUqLevel(50, item.slot_type)">
															Lv 50
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 69 ? 'active' : ''"
															@click="setUqLevel(70, item.slot_type)">
															Lv 70
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 89 ? 'active' : ''"
															@click="setUqLevel(90, item.slot_type)">
															Lv 90
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 109 ? 'active' : ''"
															@click="setUqLevel(110, item.slot_type)">
															Lv 110
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 129 ? 'active' : ''"
															@click="setUqLevel(130, item.slot_type)">
															Lv 130
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 139 ? 'active' : ''"
															@click="setUqLevel(140, item.slot_type)">
															Lv 140
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 149 ? 'active' : ''"
															@click="setUqLevel(150, item.slot_type)">
															Lv 150
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 159 ? 'active' : ''"
															@click="setUqLevel(160, item.slot_type)">
															Lv 160
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 169 ? 'active' : ''"
															@click="setUqLevel(170, item.slot_type)">
															Lv 170
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 179 ? 'active' : ''"
															@click="setUqLevel(180, item.slot_type)">
															Lv 180
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 189 ? 'active' : ''"
															@click="setUqLevel(190, item.slot_type)">
															Lv 190
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 199 ? 'active' : ''"
															@click="setUqLevel(200, item.slot_type)">
															Lv 200
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 209 ? 'active' : ''"
															@click="setUqLevel(210, item.slot_type)">
															Lv 210
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 219 ? 'active' : ''"
															@click="setUqLevel(220, item.slot_type)">
															Lv 220
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 229 ? 'active' : ''"
															@click="setUqLevel(230, item.slot_type)">
															Lv 230
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 239 ? 'active' : ''"
															@click="setUqLevel(240, item.slot_type)">
															Lv 240
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 249 ? 'active' : ''"
															@click="setUqLevel(250, item.slot_type)">
															Lv 250
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 259 ? 'active' : ''"
															@click="setUqLevel(260, item.slot_type)">
															Lv 260
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 269 ? 'active' : ''"
															@click="setUqLevel(270, item.slot_type)">
															Lv 270
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 279 ? 'active' : ''"
															@click="setUqLevel(280, item.slot_type)">
															Lv 280
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 289 ? 'active' : ''"
															@click="setUqLevel(290, item.slot_type)">
															Lv 290
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 299 ? 'active' : ''"
															@click="setUqLevel(300, item.slot_type)">
															Lv 300
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeaponLevel == 309 ? 'active' : ''"
															@click="setUqLevel(310, item.slot_type)">
															Lv 310
														</div>
													</template>
													<template v-if="item.slot_type === '2'">
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeapon2Level == 1 ? 'active' : ''"
															@click="setUqLevel(1, item.slot_type)">
															☆☆☆☆☆
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeapon2Level == 2 ? 'active' : ''"
															@click="setUqLevel(2, item.slot_type)">
															★☆☆☆☆
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeapon2Level == 3 ? 'active' : ''"
															@click="setUqLevel(3, item.slot_type)">
															★★☆☆☆
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeapon2Level == 4 ? 'active' : ''"
															@click="setUqLevel(4, item.slot_type)">
															★★★☆☆
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeapon2Level == 5 ? 'active' : ''"
															@click="setUqLevel(5, item.slot_type)">
															★★★★☆
														</div>
														<div class="pcbtn mr-2 mb-3"
															:class="uniqueWeapon2Level == 6 ? 'active' : ''"
															@click="setUqLevel(6, item.slot_type)">
															★★★★★
														</div>
													</template>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.hp != 0">
													<div class="prod-data d-flex">
														<span class="title">
															HP
														</span>
														<span class="prod-value"> {{ item.hp }} ({{
															getUeLevelMultiplier(item, "hp") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.def != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("def") }}
														</span>
														<span class="prod-value"> {{ item.def }} ({{
															getUeLevelMultiplier(item, "def") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.magic_def != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("magic_def") }}
														</span>
														<span class="prod-value"> {{ item.magic_def }} ({{
															getUeLevelMultiplier(item, "magic_def") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.atk != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("atk") }}
														</span>
														<span class="prod-value"> {{ item.atk }} ({{
															getUeLevelMultiplier(item, "atk") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.physical_penetrate != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("physical_penetrate") }}
														</span>
														<span class="prod-value"> {{ item.physical_penetrate }} ({{
															getUeLevelMultiplier(item, "physical_penetrate")
														}}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.physical_critical != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("physical_critical") }}
														</span>
														<span class="prod-value"> {{ item.physical_critical }} ({{
															getUeLevelMultiplier(item, "physical_critical")
														}}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.magic_str != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("magic_str") }}
														</span>
														<span class="prod-value"> {{ item.magic_str }} ({{
															getUeLevelMultiplier(item, "magic_str") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.magic_penetrate != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("magic_penetrate") }}
														</span>
														<span class="prod-value"> {{ item.magic_penetrate }} ({{
															getUeLevelMultiplier(item, "magic_penetrate") }})
														</span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.magic_critical != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("magic_critical") }}
														</span>
														<span class="prod-value"> {{ item.magic_critical }} ({{
															getUeLevelMultiplier(item, "magic_critical") }})
														</span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.dodge != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("dodge") }}
														</span>
														<span class="prod-value"> {{ item.dodge }} ({{
															getUeLevelMultiplier(item, "dodge") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.accuracy != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("accuracy") }}
														</span>
														<span class="prod-value"> {{ item.accuracy }} ({{
															getUeLevelMultiplier(item, "accuracy") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.life_steal != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("life_steal") }}
														</span>
														<span class="prod-value"> {{ item.life_steal }} ({{
															getUeLevelMultiplier(item, "life_steal") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.hp_recovery_rate != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("hp_recovery_rate") }}
														</span>
														<span class="prod-value"> {{ item.hp_recovery_rate }} ({{
															getUeLevelMultiplier(item, "hp_recovery_rate") }})
														</span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.wave_hp_recovery != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("wave_hp_recovery") }}
														</span>
														<span class="prod-value"> {{ item.wave_hp_recovery }} ({{
															getUeLevelMultiplier(item, "wave_hp_recovery") }})
														</span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.wave_energy_recovery != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("wave_energy_recovery") }}
														</span>
														<span class="prod-value"> {{ item.wave_energy_recovery }} ({{
															getUeLevelMultiplier(item,
																"wave_energy_recovery") }}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.energy_reduce_rate != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("energy_reduce_rate") }}
														</span>
														<span class="prod-value"> {{ item.energy_reduce_rate }} ({{
															getUeLevelMultiplier(item, "energy_reduce_rate")
														}}) </span>
													</div>
												</div>
												<div class="col-lg-6 col-12 mb-3" v-if="item.energy_recovery_rate != 0">
													<div class="prod-data d-flex">
														<span class="title">
															{{ $t("energy_recovery_rate") }}
														</span>
														<span class="prod-value"> {{ item.energy_recovery_rate }} ({{
															getUeLevelMultiplier(item,
																"energy_recovery_rate") }}) </span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="row my-3">
					<div class="col-12">
						<h3 class="item-title">
							{{ $t("UnitStatus") }}
							<small><br />註: 裝備強化MAX、星等5、羈絆滿、無專武、正負差1。 </small>
							<small><br /><a target="_blank"
									href="https://priconne-redive.jp/news/information/13292/">Rank Bonus</a>
								開啟為7/12後的數值，關閉為7/12前。 若無改變表示無資料</small>
							<small v-if="unit_id == '170201' || unit_id == '170101'"><br />环奈 / 环奈（振袖）為過時資料 無更新</small>
						</h3>
						<div class="prod-info-box my-3 row">
							<div class="col-12 mb-3">
								<div class="d-flex justify-content-lg-end justify-content-start">
									<button v-if="unit_unique_equip_data.equipment_id != null" @click="countUqData"
										class="pcbtn" :class="this.countUq ? 'active' : ''">
										{{ $t("WithUE") }}
									</button>
									<button @click="activeRankBonus" class="pcbtn ml-3"
										:class="this.RankBonus ? 'active' : ''">Rank
										Bonus</button>
								</div>
							</div>
							<div class="col-12">
								<div class="form-group row">
									<label class="col-form-label col-sm-1">{{ $t("Level") }}</label>
									<div class="col-sm-11">
										<input class="form-control mb-3" type="number" name="" v-model="level"
											value="112" />
									</div>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group row">
									<label class="col-form-label col-sm-2">
										Rank
									</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="rank">
											<option value="33">33</option>
											<option value="32">32</option>
											<option value="31">31</option>
											<option value="30">30</option>
											<option value="29">29</option>
											<option value="28">28</option>
											<option value="27">27</option>
											<option value="26">26</option>
											<option value="25">25</option>
											<option value="24">24</option>
											<option value="23">23</option>
											<option value="22">22</option>
											<option value="21">21</option>
											<option value="20">20</option>
											<option value="19">19</option>
											<option value="18">18</option>
											<option value="17">17</option>
											<option value="16">16</option>
											<option value="15">15</option>
											<option value="14">14</option>
											<option value="13">13</option>
											<option value="12">12</option>
											<option value="11">11</option>
											<option value="10">10</option>
											<option value="9">9</option>
											<option value="8">8</option>
											<option value="7">7</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group row">
									<label class="col-form-label col-sm-2">{{ $t("Wear") }}</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="wear">
											<option value="0">0</option>
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
											<option value="6">6</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group row">
									<label class="col-form-label col-sm-2">{{ $t("StarRank") }}</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="star">
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
											<option value="6" v-if="star6">6</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-12"></div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										HP
									</span>
									<span class="prod-value">
										{{ status.hp }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("life_steal") }}
									</span>
									<span class="prod-value">
										{{ status.life_steal }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("wave_hp_recovery") }}
									</span>
									<span class="prod-value">
										{{ status.wave_hp_recovery }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("wave_energy_recovery") }}
									</span>
									<span class="prod-value">
										{{ status.wave_energy_recovery }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("energy_recovery_rate") }}
									</span>
									<span class="prod-value">
										{{ status.energy_recovery_rate }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("energy_reduce_rate") }}
									</span>
									<span class="prod-value">
										{{ status.energy_reduce_rate }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("atk") }}
									</span>
									<span class="prod-value">
										{{ status.atk }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("magic_str") }}
									</span>
									<span class="prod-value">
										{{ status.magic_str }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("accuracy") }}
									</span>
									<span class="prod-value">
										{{ status.accuracy }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("def") }}
									</span>
									<span class="prod-value">
										{{ status.def }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("magic_def") }}
									</span>
									<span class="prod-value">
										{{ status.magic_def }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("dodge") }}
									</span>
									<span class="prod-value">
										{{ status.dodge }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("physical_critical") }}
									</span>
									<span class="prod-value">
										{{ status.physical_critical }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("magic_critical") }}
									</span>
									<span class="prod-value">
										{{ status.magic_critical }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("hp_recovery_rate") }}
									</span>
									<span class="prod-value">
										{{ status.hp_recovery_rate }}
									</span>
								</div>
							</div>
							<div class="col-12 col-lg-4 mb-3">
								<div class="prod-data d-flex">
									<span class="title">
										{{ $t("search_area_width") }}
									</span>
									<span class="prod-value">
										{{ unit_data.search_area_width }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-if="clientWidth <= 1800">
					<div class="col-12">
						<ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-8839550417970110"
							data-ad-slot="9467307938" data-ad-format="auto" data-full-width-responsive="true"></ins>
					</div>
				</div>
				<div class="row my-3">
					<div class="col-12">
						<h3 class="item-title">
							{{ $t("Skill") }}
							<small v-if="unit_id == '170201' || unit_id == '170101'"><br />环奈 / 环奈（振袖）為過時資料 無更新</small>
						</h3>
						<div class="skill-box my-3" v-for="(item, key) in unit_skill">
							<div class="row">
								<div class="col-lg-2 col-12">
									<div class="skill-img d-flex justify-content-center align-items-center">
										<img class="img-fluid"
											:src="'/static/images/skill/icon_skill_' + item.icon_type + '.png'"
											alt="" />
									</div>
								</div>
								<div class="col-lg-5 col-12">
									<div class="skill-description">
										<div class="skill-type mb-1" :class="key">{{ skillType(key) }}</div>
										<h3 class="skill-name">{{ getI18nName(item, "name") }}</h3>
										{{ getI18nName(item, "description") }}
									</div>
								</div>
								<div class="col-lg-5 col-12">
									<div class="skill-effect">
										<div v-for="skill in item.Detail" class="mb-2">
											<div v-if="skill.description != ''">{{ getI18nName(skill,
												"description").replace("{0}",
													getDescription(skill)) }}。</div>
											<div v-if="skill.action_type == '10'">{{ $t("Lasts") }}：【{{
												skill.action_value_4 }}】 {{
													$t("Sec") }}。</div>
											<div v-if="skill.action_type == '11'">{{ $t("Lasts") }}：【{{
												skill.action_value_1 }}】 {{
													$t("Sec") }}。</div>
											<div v-if="skill.action_type == '72'">{{ $t("Lasts") }}：【{{
												skill.action_value_3 }}】 {{
													$t("Sec") }}。</div>
											<div v-if="skill.action_type == '12'">{{ $t("Lasts") }}：【{{
												skill.action_value_1 }}】 {{
													$t("Sec") }}。</div>
											<div
												v-if="skill.action_type == '8' || skill.action_type == '9' || skill.action_type == '38'">
												<span v-if="skill.action_type == '8'">{{ $t("Action_Speed") }} {{
													skill.action_value_1
												}} {{ $t("speed_time") }}。<br /></span>
												{{ $t("Lasts") }}：【{{ skill.action_value_3 }}】 {{ $t("Sec") }}。
											</div>
											<div v-if="skill.action_type == '21' && skill.action_value_1 != 0">{{
												$t("Lasts") }}：【{{
													skill.action_value_1 }} + {{ skill.action_value_2 }}*{{ $t("SkillLevel")
												}}】 {{
													$t("Sec") }}。</div>
											<div v-if="skill.action_type == '83'">{{ $t("Action_Speed") }} {{
												skill.action_value_1 }}{{
													$t("speed_time") }}，{{ $t("Lasts") }}：【{{ skill.action_value_3 }}】 {{
													$t("Sec") }}。
											</div>
											<div v-if="skill.action_type == '26'" style="margin-bottom: -10px;">{{
												$t("DescriptionType")
											}}：{{ descriptionType(skill) }}。</div>
											<div
												v-if="skill.target_range != 0 && skill.target_range != -1 && skill.target_range != '2160' && skill.description != ''">
												{{ $t("target_range") }}：【{{ skill.target_range }}】。</div>
											<div v-if="skill.summon">{{ skill.summon.description.replace("{0}",
												getDescription(skill.summon)) }}。</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import chara_story_status from "../assets/edata/chara_story_status.txt";
import unit_unique_equip from "../assets/edata/unit_unique_equipment.txt";
import unique_equipment_data from "../assets/edata/unique_equipment_data.txt";
import unit_ex_equipment_slot from "../assets/edata/unit_ex_equipment_slot.txt";
import ex_equipment_category from "../assets/edata/ex_equipment_category.txt";
//import unique_equipment_enhance_data from '../assets/edata/unique_equipment_enhance_data.txt'
import unique_equip_enhance_rate from "../assets/edata/unique_equip_enhance_rate.txt";
import unit_talent from "../assets/edata/unit_talent.txt";
import skill_action from "../assets/edata/skill_action.txt";
import skill_data from "../assets/edata/skill_data.txt";
import unit_skill_data from "../assets/edata/unit_skill_data.txt";
import unit_profile from "../assets/edata/unit_profile.txt";
import unit_attack_pattern from "../assets/edata/unit_attack_pattern.txt";
import GachaPool from "../assets/edata/gacha_pool.json";
import TwStatus from "../assets/edata/unit_promotion_status.json";
import TwStory from "../assets/edata/chara_story_status.json";
export default {
	name: "CharacterDetail",
	data() {
		return {
			unit_data: {},
			unit_profile: {},
			unit_promotion: {},
			unit_attack_pattern: {},
			unit_id: "",
			unit_skill: {},
			equipmentCraft: {},
			unit_unique_equip_data: {},
			unitExEquipmentSlot: {},
			exEquipmentCategory: {},
			unit_story: {},
			unit_status: {},
			countUq: false,
			level: 308,
			rank: "31",
			wear: "6",
			star6: false,
			star: "5",
			uniqueWeaponLevel: 309,
			uniqueWeapon2Level: 1,
			gachaPool: GachaPool,
			gachaType: "",
			topRank: "33",
			RankBonus: true,
		};
	},
	props: ["clientWidth"],
	metaInfo() {
		return {
			title: this.unit_data.unit_name + " | 角色資訊",
		};
	},
	methods: {
		getI18nName: function (item, name) {
			switch (this.locale) {
				case "cn":
					return item["cn_" + name];
					break;
				case "en":
					return item["en_" + name];
					break;
				case "jp":
					return item["jp_" + name];
					break;
				default:
					return item[name];
					break;
			}
		},
		getData: function (unitId) {
			var self = this;
		},
		getUeLevelMultiplier: function (item, attr) {
			switch (item.slot_type) {
				case "1":
					return Number(item[attr]) + Math.ceil(item.ueer[attr] * this.uniqueWeaponLevel);
					break;
				case "2":
					return Math.ceil(item.ueer[attr] * this.uniqueWeapon2Level);
					break;
			}
		},
		setUqLevel: function (lv, slot_type) {
			var self = this;
			switch (slot_type) {
				case "1":
					lv = lv - 1;
					self.uniqueWeaponLevel = Number(lv);
					break;
				case "2":
					self.uniqueWeapon2Level = Number(lv);
					break;
			}
		},
		leftOrRight: function (index) {
			switch (index.toString()) {
				case "2":
					return "left pl-5";
					break;
				case "3":
					return "text-right pr-5";
					break;
				default:
					return "text-center";
			}
		},
		getCharaImg: function (unit_id) {
			if (this.clientWidth > 1000) {
				return `background-image: url(/static/images/unit_small/${unit_id}.png)`;
			}
		},
		descriptionType: function (skill) {
			switch (skill.action_value_1) {
				case "1.0":
					return `損失的HP * ${skill.action_value_2}`;
					break;
				case "4.0":
					return `${this.$t("Target")} * ${skill.action_value_2}`;
					break;
				case "8.0":
					return `${this.$t("magic_str")} * ${skill.action_value_2}`;
					break;
				case "6.0":
					return `${this.$t("atk")} * ${skill.action_value_2}`;
					break;
				case "21.0":
					return `每次使用必殺技時，追加的印記數量都會增加 ${skill.action_value_2} 個`;
					break;
				case "257.0":
					return `畏懼 * ${skill.action_value_2}`;
					break;
				case "297.0":
					return `1個印 技能傷害增加 * ${skill.action_value_2} `;
					break;
				default:
					return `${this.$t("Modifier")} * ${skill.action_value_2}`;
			}
		},
		skillType: function (type) {
			switch (type) {
				case "ex_skill_1":
					return this.$t("ex_skill_1");
				case "ex_skill_evolution_1":
					return this.$t("ex_skill_evolution_1");
				case "main_skill_1":
					return this.$t("main_skill_1");
				case "main_skill_2":
					return this.$t("main_skill_2");
				case "union_burst":
					return this.$t("union_burst");
				case "sp_skill_1":
					return this.$t("sp_skill_1");
				case "sp_skill_evolution_1":
					return this.$t("sp_skill_evolution_1");
				case "sp_skill_2":
					return this.$t("sp_skill_2");
				case "sp_skill_evolution_2":
					return this.$t("sp_skill_evolution_2");
				case "sp_skill_3":
					return this.$t("sp_skill_3");
				case "sp_skill_evolution_3":
					return this.$t("sp_skill_evolution_3");
					return "特殊技能3+";
				case "union_burst_evolution":
					return this.$t("union_burst_evolution");
				case "sp_union_burst":
					return this.$t("sp_union_burst");
				case "main_skill_evolution_1":
					return this.$t("main_skill_evolution_1");
				case "main_skill_evolution_2":
					return this.$t("main_skill_evolution_2");
				default:
					return;
			}
		},
		getDescription: function (skill) {
			var self = this;
			var level = self.level;
			var unit_atk = Number(self.status.atk) < Number(self.status.magic_str) ? self.status.magic_str : self.status.atk;
			switch (skill.action_type) {
				case "1":
					//物理傷害
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level + Number(skill.action_value_3) * unit_atk;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} + ${skill.action_value_3} *atk】`;
					break;
				case "4":
					//回復HP
					var number = Number(skill.action_value_2) + Number(skill.action_value_3) * level + Number(skill.action_value_4) * unit_atk;
					return ` ${self.ToCeil(number)} 【${skill.action_value_2} + ${skill.action_value_3}*${this.$t("SkillLevel")} + ${skill.action_value_4}*atk】`;
					break;
				case "6":
					//魔法無效護盾
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} 】`;
					break;
				case "9":
					//中毒
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} 】`;
					break;
				case "10":
					//物理防禦力降低
					var number = Number(skill.action_value_2) + Number(skill.action_value_3) * level;
					return `${self.ToCeil(number)} 【${skill.action_value_2} + ${skill.action_value_3}*${this.$t("SkillLevel")}】`;
					break;
				case "16":
					//回復TP
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} 】`;
					break;
				case "33":
					//召喚
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} 】`;
					break;
				case "34":
					//降低結界內的敵人的物理防禦力
					var number = Number(skill.action_value_2) + Number(skill.action_value_3) * level;
					return `${self.ToCeil(number)} 【${skill.action_value_2} + ${skill.action_value_3}*${this.$t("SkillLevel")}】`;
					break;
				case "36":
					//每秒傷害
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level + Number(skill.action_value_3) * unit_atk;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} + ${skill.action_value_3} *atk】`;
					break;
				case "37":
					//開小幅度恢復區域
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level + Number(skill.action_value_3) * unit_atk;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} + ${skill.action_value_3} *atk ${this.$t("Lasts")} ${skill.action_value_5} ${this.$t("Sec")}】`;
					break;
				case "38":
					//降低結界內的敵人的物理防禦力
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} 】`;
					break;
				case "48":
					// 每秒回復 HP
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level + Number(skill.action_value_3) * unit_atk;
					return ` ${self.ToCeil(number)} 【${skill.action_value_1} + ${skill.action_value_2}*${this.$t("SkillLevel")} + ${skill.action_value_3} *atk ${this.$t("Lasts")} ${skill.action_value_5} ${this.$t("Sec")}】`;
					break;
				case "50":
					// 範圍防禦上升
					var number = Number(skill.action_value_2) + Number(skill.action_value_3) * level;
					return `${self.ToCeil(number)} 【${skill.action_value_2} + ${skill.action_value_3}*${this.$t("SkillLevel")}】`;
					break;
				case "72":
					// 減少{0}％我方單體受到的物理傷害
					var number = Number(skill.action_value_1) + Number(skill.action_value_2) * level;
					return `${self.ToCeil(number)} `;
					break;
				case "90":
					var number = Number(skill.action_value_2) + Number(skill.action_value_3) * level;
					return `${self.ToCeil(number)} 【${skill.action_value_2} + ${skill.action_value_3}*${this.$t("SkillLevel")}】`;
					break;
				default:
					return;
			}
		},
		getSkill: function (unit_id) {
			var self = this;
			var unitSkillData = JSON.parse(self.atou(unit_skill_data));
			var unit_Skill = _.find(unitSkillData, ["unit_id", unit_id.toString()]);
			self.unit_data["unit_skill_id"] = {
				union_burst: unit_Skill.union_burst,
				union_burst_evolution: unit_Skill.union_burst_evolution,
				sp_union_burst: unit_Skill.sp_union_burst,
				main_skill_1: unit_Skill.main_skill_1,
				main_skill_evolution_1: unit_Skill.main_skill_evolution_1,
				main_skill_2: unit_Skill.main_skill_2,
				main_skill_evolution_2: unit_Skill.main_skill_evolution_2,
				sp_skill_1: unit_Skill.sp_skill_1,
				sp_skill_evolution_1: unit_Skill.sp_skill_evolution_1,
				sp_skill_2: unit_Skill.sp_skill_2,
				sp_skill_evolution_2: unit_Skill.sp_skill_evolution_2,
				sp_skill_3: unit_Skill.sp_skill_3,
				ex_skill_1: unit_Skill.ex_skill_1,
				ex_skill_evolution_1: unit_Skill.ex_skill_evolution_1,
			};
			var skillData = JSON.parse(self.atou(skill_data));
			var getSkillAction = JSON.parse(self.atou(skill_action));
			_.forEach(self.unit_data["unit_skill_id"], function (o, key) {
				let skill = _.find(skillData, ["skill_id", o]);
				if (!skill) {
					return;
				}
				var skillAction = _.filter(_.pick(skill, ["action_1", "action_2", "action_3", "action_4", "action_5", "action_6", "action_7"]), function (o) {
					return o != "0";
				});
				var skillActionDetail = new Array();
				_.forEach(skillAction, function (o, key) {
					var skill = _.find(getSkillAction, ["action_id", o]);
					if (!skill) {
						return;
					}

					if (skill.action_type == "15") {
						var summonSkillData = _.find(unitSkillData, ["unit_id", skill.action_detail_2]);
						if (summonSkillData) {
							var summonSkill = _.find(skillData, ["skill_id", summonSkillData.main_skill_1]);
							if (summonSkill) {
								var summonSkillDetail = _.find(getSkillAction, ["action_id", summonSkill.action_1]);
							}
							if (summonSkillDetail) {
								skill["summon"] = summonSkillDetail;
							}
						}
					}

					skillActionDetail.push(skill);
				});

				self.unit_skill[key] = skill;
				self.unit_skill[key]["Detail"] = skillActionDetail;
			});
			self.$nextTick(() => {
				this.checkIsSpecial();
			});
		},
		checkIsSpecial: function (item) {
			var self = this;
			if (self.unit_id == "100301") {
				self.unit_skill.main_skill_evolution_1.Detail[0].description = "";
				self.unit_skill.main_skill_evolution_1.Detail[1].description = "對敵方單體造成{0}的物理傷害";
				self.unit_skill.main_skill_evolution_1.Detail[2].description = "對敵方單體造成{0}的物理傷害";
				self.unit_skill.main_skill_evolution_1.Detail[3].description = "降低敵方單體{0}的物理防禦力";
				self.unit_skill.main_skill_evolution_1.Detail[4].description = "降低敵方單體{0}的物理防禦力";
				this.$forceUpdate();
			}
		},
		getPatternImg: function (unitId) {
			var self = this;
			var unitAttackPattern = JSON.parse(self.atou(unit_attack_pattern));
			var allPattern = _.filter(unitAttackPattern, function (o) {
				return _.includes(o.pattern_id, unitId.toString()) && o.unit_id == unitId.toString();
			});
			var myPattern = new Array();
			_.forEach(allPattern, function (pattern) {
				var loopStart = Number(pattern.loop_start);
				var loopEnd = Number(pattern.loop_end);
				var i, j;
				var start = new Array();
				for (i = 1; i <= loopStart - 1; i++) {
					switch (pattern["atk_pattern_" + i]) {
						case "1":
							start.push("attack");
							break;
						case "1001":
							start.push("ap01");
							break;
						case "1002":
							start.push("ap02");
							break;
						case "2001":
							start.push("sp01");
							break;
						case "2002":
							start.push("sp02");
							break;
						case "2003":
							start.push("sp03");
							break;
					}
				}
				var loop = new Array();
				for (j = loopStart; j <= loopEnd; j++) {
					switch (pattern["atk_pattern_" + j]) {
						case "1":
							loop.push("attack");
							break;
						case "1001":
							loop.push("ap01");
							break;
						case "1002":
							loop.push("ap02");
							break;
						case "2001":
							loop.push("sp01");
							break;
						case "2002":
							loop.push("sp02");
							break;
						case "2003":
							loop.push("sp03");
							break;
					}
				}
				var unit_attack_pattern = {
					start: start,
					loop: loop,
				};
				myPattern.push(unit_attack_pattern);
			});
			self.unit_attack_pattern = myPattern;
		},
		getUniqueData: function (unitId) {
			var self = this;
			var unitUniqueEquip = JSON.parse(self.atou(unit_unique_equip));

			var uueList = _.filter(unitUniqueEquip, ["unit_id", unitId]);

			if (uueList.length == 0) {
				return;
			}

			var uniqueEquipmentData = JSON.parse(self.atou(unique_equipment_data));
			const uniqueDataList = new Array();
			uueList.forEach((element) => {
				var uniqueData = _.find(uniqueEquipmentData, ["equipment_id", element.equip_id]);
				if (!uniqueData) {
					return;
				}
				uniqueData["slot_type"] = element.equip_slot;

				//var uniqueEquipmentEnhanceData = JSON.parse(self.atou(unique_equipment_enhance_data));
				var uniqueEquipmentEnhanceRate = JSON.parse(self.atou(unique_equip_enhance_rate));
				var uniqueEnhanceRate = _.find(uniqueEquipmentEnhanceRate, ["equipment_id", uniqueData.equipment_id]);
				if (uniqueEnhanceRate) {
					uniqueData["ueer"] = uniqueEnhanceRate;
				} else {
					uniqueData["ueer"] = {
						accuracy: "0.0",
						atk: "0.0",
						def: "0.0",
						description: "",
						dodge: "0.0",
						energy_recovery_rate: "0.0",
						energy_reduce_rate: "0.0",
						equipment_id: "",
						equipment_name: "",
						hp: "0.0",
						hp_recovery_rate: "0.0",
						life_steal: "0.0",
						magic_critical: "0",
						magic_def: "0.0",
						magic_penetrate: "0.0",
						magic_str: "0",
						physical_critical: "0.0",
						physical_penetrate: "0.0",
						promotion_level: "0",
						wave_energy_recovery: "0.0",
						wave_hp_recovery: "0.0",
					};
				}
				uniqueDataList.push(uniqueData);
			});
			self.unit_unique_equip_data = uniqueDataList;
		},
		getEquipment: function (unit_id) {
			var self = this;
			var unitEq = _.filter(self.$store.getters.getUnitPromotion, function (o) {
				return _.includes(o.unit_id, unit_id);
			});
			var equipmentList = new Array();
			_.forEach(unitEq, function (eq) {
				for (var i = 1; i <= 6; i++) {
					equipmentList.push(eq["equip_slot_" + i]);
				}
			});
			var promo = _.chunk(equipmentList, 6);
			var promoList = new Array();
			_.forEach(promo, function (list) {
				var level = new Array();
				_.forEach(list, function (o) {
					var eqName = "";
					if (o != "999999") {
						var eqCraft = _.find(self.$store.getters.getEquipmentData, ["equipment_id", o]);
						if (eqCraft) {
							eqName = eqCraft.equipment_name;
						} else {
							eqName = "";
						}
					}
					var eq = {
						eq_id: o,
						eq_name: eqName,
					};
					level.push(eq);
				});
				promoList.push(level);
			});
			self.unit_promotion = promoList;
		},
		getUnitName: function (chara_id) {
			var self = this;
			var unit_id = chara_id + "01";
			var unitProfile = JSON.parse(self.atou(unit_profile));
			var unit = _.find(unitProfile, ["unit_id", unit_id]);
			return unit.unit_name;
		},
		getUnitStory: function (unit_id) {
			var self = this;
			var chara_id = unit_id.slice(0, -2);
			var charaStoryStatus = JSON.parse(self.atou(chara_story_status));
			if (!self.RankBonus) {
				var unit = _.find(TwStory, ["chara_id_1", chara_id]);
				if (unit) {
					charaStoryStatus = TwStory;
				}
			}
			var story = _.filter(charaStoryStatus, function (chara) {
				return (
					chara.chara_id_1 == chara_id ||
					chara.chara_id_2 == chara_id ||
					chara.chara_id_3 == chara_id ||
					chara.chara_id_4 == chara_id ||
					chara.chara_id_5 == chara_id ||
					chara.chara_id_6 == chara_id ||
					chara.chara_id_7 == chara_id ||
					chara.chara_id_8 == chara_id ||
					chara.chara_id_9 == chara_id ||
					chara.chara_id_10 == chara_id
				);
			});
			var storyList = _.groupBy(story, "chara_id_1");
			self.unit_story = storyList;
		},
		getUnitStatus: function (unit_id) {
			var self = this;
			var unit_status = {
				accuracy: 0,
				atk: 0,
				def: 0,
				dodge: 0,
				energy_recovery_rate: 0,
				energy_reduce_rate: 0,
				hp: 0,
				hp_recovery_rate: 0,
				life_steal: 0,
				magic_critical: 0,
				magic_def: 0,
				magic_penetrate: 0,
				magic_str: 0,
				physical_critical: 0,
				physical_penetrate: 0,
				wave_energy_recovery: 0,
				wave_hp_recovery: 0,
			};
			var chara_id = unit_id.slice(0, -2);
			var charaStoryStatus = JSON.parse(self.atou(chara_story_status));
			if (!self.RankBonus) {
				charaStoryStatus = TwStory;
			}
			var storyUp = _.filter(charaStoryStatus, function (chara) {
				return (
					chara.chara_id_1 == chara_id ||
					chara.chara_id_2 == chara_id ||
					chara.chara_id_3 == chara_id ||
					chara.chara_id_4 == chara_id ||
					chara.chara_id_5 == chara_id ||
					chara.chara_id_6 == chara_id ||
					chara.chara_id_7 == chara_id ||
					chara.chara_id_8 == chara_id ||
					chara.chara_id_9 == chara_id ||
					chara.chara_id_10 == chara_id
				);
			});
			_.forEach(storyUp, function (su) {
				for (var i = 1; i <= 5; i++) {
					if (su["status_rate_" + i] != "0") {
						switch (su["status_type_" + i]) {
							case "1":
								unit_status.hp += Number(su["status_rate_" + i]);
								break;
							case "2":
								unit_status.atk += Number(su["status_rate_" + i]);
								break;
							case "3":
								unit_status.def += Number(su["status_rate_" + i]);
								break;
							case "4":
								unit_status.magic_str += Number(su["status_rate_" + i]);
								break;
							case "5":
								unit_status.magic_def += Number(su["status_rate_" + i]);
								break;
							case "6":
								unit_status.physical_critical += Number(su["status_rate_" + i]);
								break;
							case "7":
								unit_status.magic_critical += Number(su["status_rate_" + i]);
								break;
							case "8":
								unit_status.dodge += Number(su["status_rate_" + i]);
								break;
							case "9":
								unit_status.life_steal += Number(su["status_rate_" + i]);
								break;
							case "10":
								unit_status.wave_hp_recovery += Number(su["status_rate_" + i]);
								break;
							case "11":
								unit_status.wave_energy_recovery += Number(su["status_rate_" + i]);
								break;
							case "15":
								unit_status.hp_recovery_rate += Number(su["status_rate_" + i]);
								break;
							case "17":
								unit_status.accuracy += Number(su["status_rate_" + i]);
								break;
							default:
								break;
						}
					}
				}
			});
			self.unit_status = unit_status;
			//unit.search_area_width = o.search_area_width;
		},
		getStatusName: function (item) {
			var name = "";
			switch (item) {
				case "1":
					name = "HP";
					break;
				case "2":
					name = this.$t("atk");
					break;
				case "3":
					name = this.$t("def");
					break;
				case "4":
					name = this.$t("magic_str");
					break;
				case "5":
					name = this.$t("magic_def");
					break;
				case "6":
					name = this.$t("physical_critical");
					break;
				case "7":
					name = this.$t("magic_critical");
					break;
				case "8":
					name = this.$t("dodge");
					break;
				case "9":
					name = this.$t("life_steal");
					break;
				case "10":
					name = this.$t("wave_hp_recovery");
					break;
				case "11":
					name = this.$t("wave_energy_recovery");
					break;
				case "14":
					name = this.$t("energy_recovery_rate");
					break;
				case "15":
					name = this.$t("hp_recovery_rate");
					break;
				case "17":
					name = this.$t("accuracy");
					break;
				default:
					name = item;
					break;
					return;
			}
			return name;
		},
		getPool: function (unit_id) {
			var self = this;
			self.gachaType = _.findKey(self.gachaPool, function (item) {
				return item.indexOf(unit_id) !== -1;
			});
		},
		ToCeil: function (status) {
			var number = Number(status);
			return Math.round(number);
		},
		countUqData: function () {
			this.countUq = !this.countUq;
		},
		activeRankBonus: function () {
			this.RankBonus = !this.RankBonus;
			this.getUnitStory(this.unit_id);
			this.getUnitStatus(this.unit_id);
		},
		replaceNword: function (word) {
			return _.replace(word, new RegExp("\\\\n", "g"), " ");
		},
	},
	created: function () {
		var self = this;
		var unit_name = self.$route.params.id;
		var actualUnits = this.$store.getters.getUnitData;
		var thisUnit = _.find(actualUnits, function (o) {
			return o.tw_unit_name == unit_name || o.en_unit_name == unit_name || o.jp_unit_name == unit_name || o.unit_name == unit_name;
		});
		var unit_id = thisUnit.unit_id.toString();
		self.unit_id = unit_id;
		//start get data
		self.unit_data = _.find(self.$store.getters.getUnitData, ["unit_id", unit_id.toString()]);
		var unitProfile = JSON.parse(self.atou(unit_profile));
		_.find(unitProfile, ["unit_id", "101401"]).age = "15";
		_.find(unitProfile, ["unit_id", "112201"]).age = "15";
		_.find(unitProfile, ["unit_id", "110001"]).age = "17";
		_.find(unitProfile, ["unit_id", "101601"]).age = "17";
		_.find(unitProfile, ["unit_id", "101701"]).age = "17";
		_.find(unitProfile, ["unit_id", "110501"]).age = "17";
		_.find(unitProfile, ["unit_id", "105201"]).age = "17";
		_.find(unitProfile, ["unit_id", "115801"]).age = "17";
		_.find(unitProfile, ["unit_id", "105301"]).age = "17";
		_.find(unitProfile, ["unit_id", "114201"]).age = "17";
		_.find(unitProfile, ["unit_id", "107901"]).age = "19";
		_.find(unitProfile, ["unit_id", "104601"]).age = "19";
		var unitTalent = JSON.parse(self.atou(unit_talent));
		self.unit_profile = _.find(unitProfile, ["unit_id", unit_id.toString()]);
		const talentUnit = unitTalent.find((obj) => obj.unit_id == _.toInteger(unit_id.toString()));
		if (talentUnit) {
			self.unit_profile["talent_id"] = talentUnit.talent_id;
		}
		var has6star = _.find(self.$store.getters.getUnitRarity, { unit_id: unit_id, rarity: "6" });
		if (has6star) {
			self.star6 = true;
		}
		self.getSkill(unit_id);
		self.getPatternImg(unit_id);
		self.getEquipment(unit_id);
		self.getUniqueData(unit_id);
		self.getUnitStory(unit_id);
		self.getUnitStatus(unit_id);
		self.getPool(unit_id);
		var unitExEquipmentSlot = JSON.parse(self.atou(unit_ex_equipment_slot));
		this.unitExEquipmentSlot = unitExEquipmentSlot;
		var exEquipmentCategory = JSON.parse(self.atou(ex_equipment_category));
		this.exEquipmentCategory = exEquipmentCategory;
	},
	computed: {
		bigPic: function () {
			return "/static/images/unit_big/thumb_unit_profile_" + this.$route.params.id + ".png";
		},
		unitComment: function () {
			return this.getI18nName(this.unit_data, "comment").replaceAll("\\\\n", "<br/>");
		},
		unitName: function () {
			return this.getI18nName(this.unit_data, "unit_name");
		},
		unitGuild: function () {
			return this.getI18nName(this.unit_profile, "guild");
		},
		unitRace: function () {
			return this.getI18nName(this.unit_profile, "race");
		},
		unitFavorite: function () {
			return this.getI18nName(this.unit_profile, "favorite");
		},
		unitVoice: function () {
			return this.getI18nName(this.unit_profile, "voice");
		},
		locale() {
			return this.$i18n.locale;
		},
		getExEq() {
			var unit_id = this.unit_id;
			var exEq = _.find(this.unitExEquipmentSlot, ["unit_id", unit_id.toString()]);
			var exEquipmentCategory = this.exEquipmentCategory;
			var exList = [exEq.slot_category_1, exEq.slot_category_2, exEq.slot_category_3];
			var exCategory = [];
			_.forEach(exList, function (item) {
				var exEq = _.find(exEquipmentCategory, ["category", item.toString()]);
				exCategory.push(exEq);
			});
			return exCategory;
		},
		status: function () {
			var self = this;
			var rank = self.rank.toString();
			var wear = self.wear;
			var star = self.star;
			var growth = Number(this.level) + Number(rank);
			var unit_status = _.cloneDeep(self.unit_status);
			var ps = _.find(self.$store.getters.getUnitPromotionStatus, { unit_id: self.unit_id, promotion_level: rank });
			if (!self.RankBonus) {
				var twStatus = _.find(TwStatus, { unit_id: self.unit_id, promotion_level: rank });
				if (twStatus) {
					ps = twStatus;
				}
			}
			var ur = _.find(self.$store.getters.getUnitRarity, { unit_id: self.unit_id, rarity: star });
			var up = _.find(self.$store.getters.getUnitPromotion, { unit_id: self.unit_id, promotion_level: rank });
			if (!ps) {
				var currentPs = _.filter(self.$store.getters.getUnitPromotionStatus, function (o) {
					return o.unit_id == self.unit_id.toString();
				});
				ps = currentPs[currentPs.length - 1];
			}
			if (!up) {
				up = {
					equip_slot_1: "999999",
					equip_slot_2: "999999",
					equip_slot_3: "999999",
					equip_slot_4: "999999",
					equip_slot_5: "999999",
					equip_slot_6: "999999",
				};
			}
			var equipmentList = new Array();
			switch (wear) {
				case "0":
					up = {};
				case "3":
					up = {
						equip_slot_2: up.equip_slot_2,
						equip_slot_4: up.equip_slot_4,
						equip_slot_6: up.equip_slot_6,
					};
					break;
				case "4":
					up = {
						equip_slot_2: up.equip_slot_2,
						equip_slot_4: up.equip_slot_4,
						equip_slot_5: up.equip_slot_5,
						equip_slot_6: up.equip_slot_6,
					};
					break;
				case "5":
					up = {
						equip_slot_2: up.equip_slot_2,
						equip_slot_3: up.equip_slot_3,
						equip_slot_4: up.equip_slot_4,
						equip_slot_5: up.equip_slot_5,
						equip_slot_6: up.equip_slot_6,
					};
					break;
				default:
					up = {
						equip_slot_1: up.equip_slot_1,
						equip_slot_2: up.equip_slot_2,
						equip_slot_3: up.equip_slot_3,
						equip_slot_4: up.equip_slot_4,
						equip_slot_5: up.equip_slot_5,
						equip_slot_6: up.equip_slot_6,
					};
					break;
			}
			_.forEach(up, function (u) {
				var ed = _.find(self.$store.getters.getEquipmentData, { equipment_id: u });
				if (!ed) {
					return;
				}
				var cloneEq = _.cloneDeep(ed);
				if (!self.RankBonus) {
					switch (u) {
						case "104102":
							cloneEq.energy_recovery_rate = "12.0";
							break;
						case "104013":
							cloneEq.energy_recovery_rate = "5.0";
							break;
						case "104042":
							cloneEq.energy_recovery_rate = "10.0";
							break;
						case "104132":
							cloneEq.energy_recovery_rate = "5.0";
							break;
						case "104371":
							cloneEq.energy_recovery_rate = "5.0";
							break;
						case "104581":
							cloneEq.hp = "240.0";
							cloneEq.energy_recovery_rate = "0.0";
							cloneEq.hp_recovery_rate = "200.0";
							break;
						case "104611":
							cloneEq.hp = "100.0";
							cloneEq.magic_str = "60.0";
							cloneEq.energy_reduce_rate = "25.0";
							cloneEq.energy_recovery_rate = "0.0";
							break;
					}
				}
				equipmentList.push(cloneEq);
			});

			_.forEach(equipmentList, function (u) {
				unit_status.accuracy += Number(u.accuracy) * 2;
				unit_status.atk += Number(u.atk) * 2;
				unit_status.def += Number(u.def) * 2;
				unit_status.dodge += Number(u.dodge) * 2;
				unit_status.energy_recovery_rate += Number(u.energy_recovery_rate) * 2;
				unit_status.energy_reduce_rate += Number(u.energy_reduce_rate) * 2;
				unit_status.hp += Number(u.hp) * 2;
				unit_status.hp_recovery_rate += Number(u.hp_recovery_rate) * 2;
				unit_status.life_steal += Number(u.life_steal) * 2;
				unit_status.magic_critical += Number(u.magic_critical) * 2;
				unit_status.magic_def += Number(u.magic_def) * 2;
				unit_status.magic_penetrate += Number(u.magic_penetrate) * 2;
				unit_status.magic_str += Number(u.magic_str) * 2;
				unit_status.physical_critical += Number(u.physical_critical) * 2;
				unit_status.physical_penetrate += Number(u.physical_penetrate) * 2;
				unit_status.wave_energy_recovery += Number(u.wave_energy_recovery) * 2;
				unit_status.wave_hp_recovery += Number(u.wave_hp_recovery) * 2;
			});

			unit_status.accuracy = self.ToCeil(unit_status.accuracy + Number(ps.accuracy) + Number(ur.accuracy) + Number(ur.accuracy_growth) * growth);
			unit_status.atk = self.ToCeil(unit_status.atk + Number(ps.atk) + Number(ur.atk) + Number(ur.atk_growth) * growth);
			unit_status.def = self.ToCeil(unit_status.def + Number(ps.def) + Number(ur.def) + Number(ur.def_growth) * growth);
			unit_status.dodge = self.ToCeil(unit_status.dodge + Number(ps.dodge) + Number(ur.dodge) + Number(ur.dodge_growth) * growth);
			unit_status.energy_recovery_rate = self.ToCeil(unit_status.energy_recovery_rate + Number(ps.energy_recovery_rate) + Number(ur.energy_recovery_rate) + Number(ur.energy_recovery_rate_growth) * growth);
			unit_status.energy_reduce_rate = self.ToCeil(unit_status.energy_reduce_rate + Number(ps.energy_reduce_rate) + Number(ur.energy_reduce_rate) + Number(ur.energy_reduce_rate_growth) * growth);
			unit_status.hp = self.ToCeil(unit_status.hp + Number(ps.hp) + Number(ur.hp) + Number(ur.hp_growth) * growth);
			unit_status.hp_recovery_rate = self.ToCeil(unit_status.hp_recovery_rate + Number(ps.hp_recovery_rate) + Number(ur.hp_recovery_rate) + Number(ur.hp_recovery_rate_growth) * growth);
			unit_status.life_steal = self.ToCeil(unit_status.life_steal + Number(ps.life_steal) + Number(ur.life_steal) + Number(ur.life_steal_growth) * growth);
			unit_status.magic_critical = self.ToCeil(unit_status.magic_critical + Number(ps.magic_critical) + Number(ur.magic_critical) + Number(ur.magic_critical_growth) * growth);
			unit_status.magic_def = self.ToCeil(unit_status.magic_def + Number(ps.magic_def) + Number(ur.magic_def) + Number(ur.magic_def_growth) * growth);
			unit_status.magic_penetrate = self.ToCeil(unit_status.magic_penetrate + Number(ps.magic_penetrate) + Number(ur.magic_penetrate) + Number(ur.magic_penetrate_growth) * growth);
			unit_status.magic_str = self.ToCeil(unit_status.magic_str + Number(ps.magic_str) + Number(ur.magic_str) + Number(ur.magic_str_growth) * growth);
			unit_status.physical_critical = self.ToCeil(unit_status.physical_critical + Number(ps.physical_critical) + Number(ur.physical_critical) + Number(ur.physical_critical_growth) * growth);
			unit_status.physical_penetrate = self.ToCeil(unit_status.physical_penetrate + Number(ps.physical_penetrate) + Number(ur.physical_penetrate) + Number(ur.physical_penetrate_growth) * growth);
			unit_status.wave_energy_recovery = self.ToCeil(unit_status.wave_energy_recovery + Number(ps.wave_energy_recovery) + Number(ur.wave_energy_recovery) + Number(ur.wave_energy_recovery_growth) * growth);
			unit_status.wave_hp_recovery = self.ToCeil(unit_status.wave_hp_recovery + Number(ps.wave_hp_recovery) + Number(ur.wave_hp_recovery) + Number(ur.wave_hp_recovery_growth) * growth);

			if (self.countUq) {
				var uwl = self.uniqueWeaponLevel;
				var uqData = self.unit_unique_equip_data;
				unit_status.accuracy = unit_status.accuracy + (Number(uqData.accuracy) + Math.ceil(uqData.ueer.accuracy * uwl));
				unit_status.atk = unit_status.atk + (Number(uqData.atk) + Math.ceil(uqData.ueer.atk * uwl));
				unit_status.def = unit_status.def + (Number(uqData.def) + Math.ceil(uqData.ueer.def * uwl));
				unit_status.dodge = unit_status.dodge + (Number(uqData.dodge) + Math.ceil(uqData.ueer.dodge * uwl));
				unit_status.energy_recovery_rate = unit_status.energy_recovery_rate + (Number(uqData.energy_recovery_rate) + Math.ceil(uqData.ueer.energy_recovery_rate * uwl));
				unit_status.energy_reduce_rate = unit_status.energy_reduce_rate + (Number(uqData.energy_reduce_rate) + Math.ceil(uqData.ueer.energy_reduce_rate * uwl));
				unit_status.hp = unit_status.hp + (Number(uqData.hp) + Math.ceil(uqData.ueer.hp * uwl));
				unit_status.hp_recovery_rate = unit_status.hp_recovery_rate + (Number(uqData.hp_recovery_rate) + Math.ceil(uqData.ueer.hp_recovery_rate * uwl));
				unit_status.life_steal = unit_status.life_steal + (Number(uqData.life_steal) + Math.ceil(uqData.ueer.life_steal * uwl));
				unit_status.magic_critical = unit_status.magic_critical + (Number(uqData.magic_critical) + Math.ceil(uqData.ueer.magic_critical * uwl));
				unit_status.magic_def = unit_status.magic_def + (Number(uqData.magic_def) + Math.ceil(uqData.ueer.magic_def * uwl));
				unit_status.magic_penetrate = unit_status.magic_penetrate + (Number(uqData.magic_penetrate) + Math.ceil(uqData.ueer.magic_penetrate * uwl));
				unit_status.magic_str = unit_status.magic_str + (Number(uqData.magic_str) + Math.ceil(uqData.ueer.magic_str * uwl));
				unit_status.physical_critical = unit_status.physical_critical + (Number(uqData.physical_critical) + Math.ceil(uqData.ueer.physical_critical * uwl));
				unit_status.physical_penetrate = unit_status.physical_penetrate + (Number(uqData.physical_penetrate) + Math.ceil(uqData.ueer.physical_penetrate * uwl));
				unit_status.wave_energy_recovery = unit_status.wave_energy_recovery + (Number(uqData.wave_energy_recovery) + Math.ceil(uqData.ueer.wave_energy_recovery * uwl));
				unit_status.wave_hp_recovery = unit_status.wave_hp_recovery + (Number(uqData.wave_hp_recovery) + Math.ceil(uqData.ueer.wave_hp_recovery * uwl));
			}

			if (self.RankBonus) {
				if (Number(self.rank) > 20) {
					if (Number(unit_status.atk) > Number(unit_status.magic_str)) {
						unit_status.atk = Number(unit_status.atk) + 1800;
					} else {
						unit_status.magic_str = Number(unit_status.magic_str) + 1800;
					}

					unit_status.energy_recovery_rate = Number(unit_status.energy_recovery_rate) + 10;
				}
			}
			return unit_status;
		},
		getGachaType: function () {
			var self = this;
			var item = self.gachaType;
			var name = "";
			switch (item) {
				case "always":
					name = this.$t("PermanentGacha");
					break;
				case "season":
					name = this.$t("SeasonLimitedGacha");
					break;
				case "limited":
					name = this.$t("limited");
					break;
				case "fes":
					name = this.$t("GalaGacha");
					break;
				case "star1":
					name = this.$t("one_star");
					break;
				case "star2":
					name = this.$t("two_star");
					break;
				case "eventStar1":
					name = this.$t("event_one_star");
					break;
				case "extra":
					name = this.$t("ExtraUnit");
					break;
				default:
					name = this.$t("NotUpdated");
					break;
					return;
			}
			return name;
		},
	},
	mounted: function () {
		var self = this;
		(adsbygoogle = window.adsbygoogle || []).push({});
		$(".owl1").owlCarousel({
			loop: true,
			items: 1,
			margin: 10,
			dots: true,
			autoplaySpeed: 3000,
			autoplay: true,
		});
		$(".owl-carousel2").owlCarousel({
			loop: true,
			items: 1,
			margin: 10,
			dots: true,
			autoplay: false,
			autoHeight: true,
		});
	},
};
</script>
<style scoped>
.list-group-item {
	background-color: transparent;
}
</style>
